import React from 'react'
import { Select, Form, Button, Divider, message, Tabs, Anchor, Spin, Pagination, Tooltip, DatePicker, Steps } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import {getParmUrl,outputMoney} from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './no-nmedical-devices.module.less'
import {QuestionCircleOutlined} from '@ant-design/icons'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
class BasicInformation extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      detailsData: null,
      propertyData: []
    }
  }

  componentDidMount () {
    let {detailsData} = this.state
    detailsData = this.props.detailsData
    this.setState({
      detailsData
    })
  }

  componentWillReceiveProps (nextprops) {
    let {detailsData} = this.state
    detailsData = nextprops.detailsData
    this.setState({
      detailsData
    })
  }

  render () {
    let {propertyData, detailsData} = this.state
    return (
      <div>
        <div style={{display: 'flex', border: '1px solid #d9d9d9', paddingBottom: '24px'}}>
          {/* <div style={{width: '15%', borderRight: '1px solid #d9d9d9'}}>
            <div className={styles.informationtitle} style={{marginTop: '8%'}}>基础信息</div>
            <div className={styles.informationtitle} style={{marginTop: '130%'}}>扩展信息</div>
            <div className={styles.informationtitle}>SKU</div>
    </div> */}
          <div style={{width: '100%'}}>
            <div style={{paddingLeft: '17%', marginTop: '24px', fontSize: '16px'}}><span className={styles.titles}>基础信息</span></div>
            <div style={{display: 'flex', flexWrap: 'wrap', width: '100%', paddingLeft: '13%'}}>
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>商品名称：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.item_name : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>商品品牌：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.brand_name : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>商品类别：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.category_name : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>是否虚拟：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ?  detailsData.item_info.is_virtual === 1 ? '是' : '否'  : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>计价单位：</span>
                <span style={{ width: 244, marginRight: '4px' }} >
                  {detailsData ? detailsData.item_info.price_unit : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>规格：</span>
                <span style={{ width: 244, marginRight: '4px' }} >
                {detailsData ? detailsData.item_info.spec ?  detailsData.item_info.spec + '片装/ml' : '-': '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>经营属性：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.operation ? detailsData.item_info.operation === 'direct' ? '经销' : '代销' : '-' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>税率：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? outputMoney(detailsData.item_info.tax_rate) + '%': '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>重量：</span>
                <span  style={{ width: 244, marginRight: '4px' }} >
                  {detailsData ? detailsData.item_info.weight + '（Kg）' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>物流服务：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.logistics_service : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>资质控制：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.is_qualification === 1 ? '是' : '否' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>是否海淘：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.is_cross_border === 1 ? '是' : '否' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>包装规格：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.packing_specification : '-'}
                </span>
                <Tooltip placement="top" title='(隐形为最小起订量，护理液，润滑液，洗眼液为箱规)'>
                  <QuestionCircleOutlined style={{marginLeft: '8px'}}/>
                </Tooltip>
              </section>

            </div>

            <div style={{paddingLeft: '17%', marginTop: '64px', fontSize: '16px', display: detailsData ? detailsData.extend_propertys.length !== 0 ? 'block' : 'none' : 'none'}}><span className={styles.titles}>扩展信息</span></div>
            <div style={{display: 'flex', flexWrap: 'wrap', width: '100%', position: 'relative', paddingLeft: '13%'}}>
              {detailsData ? detailsData.extend_propertys || detailsData.extend_propertys.length !== 0 ? (
                detailsData.extend_propertys.map((item, index) => {
                  if (item.property_type === 'Extend') {
                    return (
                      <section key ={index} className={styles.publicsection}>
                        <span className={styles.publlictitle}><span className={styles.required} style={{display: item.sku_value === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                        {(item.property_name === '是否高散光高度数'||  item.property_name === '材质是否支持记忆功能' ||item.property_name === '抗UV' || item.property_name === '是否支持渐近多焦')? (
                          <span style={{ width: 244, marginRight: '0px' }} >
                          {item.extend_value ? item.extend_value ===1 ? '是' : '否' : '-'}
                        </span>
                        ):
                        <span style={{ width: 244, marginRight: '0px' }} >
                          {item.extend_value ? item.extend_value : '-'}
                        </span>
                    }
                      </section>
                    )
                  }
                })
              ) : null : null}
            </div>

            <div style={{paddingLeft: '17%', marginTop: '64px', fontSize: '16px', display: detailsData ? detailsData.sku_propertys.length !== 0 ? 'block' : 'none' : 'none'}}><span className={styles.titles}>SKU</span></div>
            <div style={{display: 'flex', flexWrap: 'wrap', width: '100%', position: 'relative', paddingLeft: '13%'}}>
              {detailsData ? detailsData.sku_propertys || detailsData.sku_propertys.length !== 0 ? (
                detailsData.sku_propertys.map((item, index) => {
                  if (item.property_type === 'SKU') {
                    return (
                      <section key ={index} className={styles.publicsection}>
                        <span className={styles.publlictitle}><span className={styles.required} style={{display: item.sku_value === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                        <span style={{ width: 244, marginRight: '0px' }} >
                          {item.sku_value ? (
                            item.sku_value.map((item2,index2)=>{
                              return <span key={index2}>{item2 !== '' ? item2 + '/' : item2}</span>
                            })

                          ) : '-'}
                        </span>
                      </section>
                    )
                  }
                })
              ) : null : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default BasicInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commoditydetails/completeinformationdetails/nonmedicaldevicesdetails/basic-information.js